module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Light.7698b7c8.ttf";